import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Checkbox, CircularProgress } from "@mui/material";
import Button from "@mui/material/Button";
import Projectcolors from "../../Utils/Colors";
import { baseURL } from "../../Config/config";
import GlobalLoader from "../CommonC/GlobalLoader";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Typography } from "@mui/material";
import Radio from "@mui/material/Radio";
import Plot from "react-plotly.js";

export default function SelectKpi(props) {
  const [dataArray, setdataArray] = React.useState(null);
  const [independent, setIndependent] = React.useState([]);
  const [dependent, setDependent] = React.useState([]);
  const [checkedindependent, setcheckedin] = React.useState(
    new Array(100).fill(false)
  );
  const [checkeddependent, setcheckedde] = React.useState(
    new Array(100).fill(false)
  );
  const [indb, setindb] = React.useState([]);
  const [dedb, setdedb] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [getLoader, setGetLoader] = React.useState(false);
  const [kpierrr, setkpierr] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [timeseries, setTimeseries] = React.useState(0);
  const [value, setValue] = React.useState("1");
  const [selectedValue, setSelectedValue] = React.useState(0);
  const [ranks, setRanks] = React.useState([]);
  const [spearman, setSpearman] = React.useState(0);
  const [save, setSave] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === "2") {
      if (save) {
        setSpearman(1);
        getSpearman();
      } else {
        setSpearman(0);
      }
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeRadio = (item, position) => {
    setSelectedValue(position);
  };

  const getSpearman = () => {
    setGetLoader(true);
    const ProjectID = sessionStorage.getItem("projectID");
    fetch(`${baseURL}/getSpearman?projectID=${ProjectID}`)
      .then((res) => res.json())
      .then((myresponse) => {
        setRanks(myresponse.allranks);
        setIndependent(myresponse.independent);
        setDependent(myresponse.dependent);
        setGetLoader(false);
      })
      .catch((err) => {
        setGetLoader(false);
        console.log("error", err);
      });
  };

  React.useEffect(() => {
    getSelectKpi();
    getSpearman();
  }, []);

  function getcheckstatus(data) {
  setIndependent(data.independent);
  setDependent(data.dependent);

  let newinArray = [...checkedindependent];
  let newdeArray = [...checkeddependent];

  if (data.independent.length > 0) {
    data.independent.forEach((indbitem) => {
      data.allkpi.forEach((item, i) => {
        if (indbitem === item[1]) {
          newinArray[i] = true;
        }
      });
    });
  }

  if (data.dependent.length > 0) {
    data.dependent.forEach((dedbitem) => {
      data.allkpi.forEach((item, i) => {
        if (dedbitem === item[1]) {
          newdeArray[i] = true;
        }
      });
    });
  }

  setcheckedin(newinArray);
  setcheckedde(newdeArray);
}

  const getSelectKpi = () => {
    setGetLoader(true);
    if (props.loaded) {
      sessionStorage.setItem("projectID", props.ProjectID);
    }

    const ProjectID = sessionStorage.getItem("projectID");
    const body = {
      ProjectID,
    };

    const options = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      // body: JSON.stringify(body),
    };
    fetch(
      `${baseURL}/selectkpi?projectID=${ProjectID}&loaded=${props.loaded}`,
      options
    )
      .then((res) => res.json())
      .then((kpidata) => {
        setdataArray(kpidata.allkpi);
        setTimeseries(kpidata.timeseries);
        //initializecheckstatus(kpidata.allkpi);
        if (props.loaded || kpidata.independent) {
          getcheckstatus(kpidata);
          if (kpidata.independent.length > 0 && kpidata.dependent.length > 0) {
            setSave(1);
          }
        }
        setGetLoader(false);
      })
      .catch((err) => {
        setGetLoader(false);
        console.log("There was an error", err);
      });
  };

  const handleSubmit = () => {
    const ProjectID = sessionStorage.getItem("projectID");
    setIsLoading(true);
    console.log(independent)
    console.log(dependent)
    try {
      fetch(`${baseURL}/savekpi`, {
        method: "POST",
        body: JSON.stringify({
          independent: independent,
          dependent: dependent,
          ProjectID: ProjectID,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((result) => {
          setIsLoading(false);
          setSave(1);
          alert("KPI Saved Successfully")
          //props.handleNextStep();
        })
        .catch((error) => {
          setIsLoading(false);
          console.error("Error:", error);
        });
    } catch (error) {
      setIsLoading(false);
      console.log("Error", error);
    }
  };

const handleIndependentChange = (e, i) => {
  if (checkedindependent) {
    if (dependent.includes(e.target.value)) {
      setOpen(true);
    } else {
      // create new array copy
      let newinArray = [...checkedindependent];

      newinArray[i] = e.target.checked;

      setcheckedin(newinArray);

      if (e.target.checked) {
        setIndependent((prev) => [...prev, e.target.value]);
      } else {
        const newData = independent.filter(
          (x) => x !== e.target.value
        );
        setIndependent(newData);
      }
    }
  }
};

  const handledependentChange = (e, i) => {
  if (checkeddependent) {
    if (independent.includes(e.target.value)) {
      setOpen(true);
    } else {

      let newdeArray = [...checkeddependent];
      newdeArray[i] = e.target.checked;

      setcheckedde(newdeArray);

      if (e.target.checked) {
        setDependent((prev) => [...prev, e.target.value]);
      } else {
        const newData = dependent.filter(
          (x) => x !== e.target.value
        );
        setDependent(newData);
      }
    }
  }
};
  const handleNext = () => {
    props.handleNextStep();
  };

  const disabled = !independent.length || !dependent.length;
return (
  <Box
    sx={{
      width: "1000px",
      margin: "30px auto",
      position: "relative",
    }}
  >
    {/* background glow */}

    <Box
      sx={{
        position: "absolute",
        top: -100,
        left: -100,
        width: 300,
        height: 300,
        borderRadius: "50%",
        background:
          "radial-gradient(circle, rgba(0,120,201,.15), transparent)",
        filter: "blur(50px)",
      }}
    />

    <Box
      sx={{
        position: "absolute",
        right: -80,
        bottom: -100,
        width: 300,
        height: 300,
        borderRadius: "50%",
        border:2,
        borderColor:"#0078c9",
        background:
          "radial-gradient(circle, rgba(158,11,34,.10), transparent)",
        filter: "blur(60px)",
      }}
    />

    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: "30px",
        background: "rgba(255,255,255,.9)",
        backdropFilter: "blur(30px)",
        boxShadow: "0 15px 50px rgba(0,0,0,.08)",
        border:2,
        borderColor:"#0078c9",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 700,
          color: "#0078c9",
          mb: 1,
        }}
      >
        Indicator Configuration
      </Typography>

      <TabContext value={value}>
        {/* modern pill tabs */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 2,
          }}
        >
          <TabList
            onChange={handleChange}
            TabIndicatorProps={{
              style: {
                display: "none",
              },
            }}
            sx={{
              bgcolor: "#f6f9fc",
              p: .8,
              borderRadius: "100px",

              "& .MuiTabs-flexContainer": {
                gap: 1,
              },

              "& .MuiTab-root": {
                fontSize: "12px",
                minHeight: 40,
                textTransform: "none",
                borderRadius: "50px",
                color: "#555",
                transition: ".3s",
              },

              "& .Mui-selected": {
                bgcolor: "#0078c9",
                color: "#fff !important",
              },
            }}
          >
            <Tab
              label="Define Indicators"
              value="1"
            />

            <Tab
              label="Evaluate Indicators"
              value="2"
            />
          </TabList>
        </Box>

        {/* TAB 1 */}

        <TabPanel value="1">

          <Paper
            elevation={0}
            sx={{
              borderRadius: "24px",
              overflow: "hidden",
              bgcolor: "#fff",
              boxShadow:
                "0 5px 25px rgba(0,0,0,.06)",
            }}
          >
            <TableContainer sx={{height:450}}>

              <Table stickyHeader>

                <TableHead>

                  <TableRow>

                    {dataArray &&
                      dataArray[0].map((item)=>(

                        <TableCell
                          sx={{
                            bgcolor:"#0078c9",
                            fontSize:"12px",
                            fontWeight:700,
                            color:"#fff"
                          }}
                        >
                          {item}
                        </TableCell>

                      ))}

                    <TableCell
                      sx={{
                            bgcolor:"#0078c9",
                            fontSize:"12px",
                            fontWeight:700,
                            color:"#fff"
                          }}
                    >
                      Independent
                    </TableCell>

                    <TableCell
                      sx={{
                            bgcolor:"#0078c9",
                            fontSize:"12px",
                            fontWeight:700,
                            color:"#fff"
                          }}
                    >
                      Dependent
                    </TableCell>

                  </TableRow>

                </TableHead>

                <TableBody>

                  {dataArray?.map((item,i)=>{

                    if(i>0){

                    return(

                      <TableRow
                        hover
                        sx={{
                          transition:".2s",

                          "&:hover":{
                            bgcolor:"#f9fbfd"
                          }
                        }}
                      >

                        {item.map((data)=>(

                          <TableCell
                            sx={{
                              fontSize:"12px",
                              color:"#444"
                            }}
                          >
                            {data}
                          </TableCell>

                        ))}

                        <TableCell>

                        <Checkbox
  value={item[1]}
  checked={checkedindependent[i] || false}
  onChange={(e) => handleIndependentChange(e, i)}
  sx={{
    color:"#0078c9",
    "&.Mui-checked":{
      color:"#9e0b22"
    }
  }}
/>

                        </TableCell>

                        <TableCell>

                          <Checkbox
                            value={item[1]}
  checked={checkeddependent[i] || false}
  onChange={(e) => handledependentChange(e, i)}

                            sx={{
                              color:"#0078c9",

                              "&.Mui-checked":{
                                color:"#9e0b22"
                              }
                            }}
                          />

                        </TableCell>

                      </TableRow>

                    )

                    }

                  })}

                </TableBody>

              </Table>

            </TableContainer>

          </Paper>

          <Box
            sx={{
              mt:3,
              display:"flex",
              justifyContent:"flex-end",
              gap:2
            }}
          >

            <Button
              onClick={handleSubmit}
              variant="contained"
              sx={{
                bgcolor:"#0078c9",
                textTransform:"none",
                fontSize:"12px",
                px:3,
                borderRadius:"14px",
                boxShadow:"none",

                "&:hover":{
                  bgcolor:"#9e0b22"
                }
              }}
            >
              Save
            </Button>

            <Button
              onClick={handleNext}
              variant="contained"
              sx={{
                bgcolor:"#0078c9",
                textTransform:"none",
                fontSize:"12px",
                px:3,
                borderRadius:"14px",
                boxShadow:"none",

                "&:hover":{
                  bgcolor:"#9e0b22"
                }
              }}
            >
              Next Step
            </Button>

          </Box>

        </TabPanel>

        {/* TAB 2 */}

        <TabPanel value="2">

          <Box
            sx={{
              display:"flex",
              gap:3
            }}
          >

            {/* left panel */}

            <Paper
              elevation={0}
              sx={{
                width:240,
                p:2,
                borderRadius:"24px",
                bgcolor:"#fff",
                boxShadow:
                  "0 4px 25px rgba(0,0,0,.05)"
              }}
            >

              <Typography
                sx={{
                  fontSize:"12px",
                  fontWeight:700,
                  mb:2,
                  color:"#0078c9"
                }}
              >
                Variables
              </Typography>

              {dependent?.map((item,i)=>(

                <Box
                  sx={{
                    display:"flex",
                    alignItems:"center"
                  }}
                >

                  <Radio
                    checked={selectedValue===i}
                    onChange={()=>
                      handleChangeRadio(item,i)
                    }

                    sx={{
                      color:"#0078c9",

                      "&.Mui-checked":{
                        color:"#9e0b22"
                      }
                    }}
                  />

                  <Typography
                    sx={{
                      fontSize:"12px"
                    }}
                  >
                    {item}
                  </Typography>

                </Box>

              ))}

            </Paper>


            {/* graph */}

            <Paper
              elevation={0}
              sx={{
                flex:1,
                p:2,
                borderRadius:"24px",
                bgcolor:"#fff",
                boxShadow:
                  "0 4px 25px rgba(0,0,0,.05)"
              }}
            >

              <Plot
                data={[
                  {
                    x: independent,
                    y: ranks[selectedValue],
                    type:"bar",
                    width:.3
                  }
                ]}

                layout={{
                  width:550,
                  height:330,
                  title:"MB Ranking Plot"
                }}

                config={{
                  displaylogo:false
                }}
              />

            </Paper>

          </Box>

        </TabPanel>

      </TabContext>
    </Paper>
  </Box>
);
}
